import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { PasswordInput } from "@/components/PasswordInput";
import { inputCls } from "./shared";

const EMPTY = { current_password: "", new_password: "", confirm_password: "" };
const MIN_LENGTH = 10;

const FIELDS = [
  ["current_password", "Current password", "current-password-input", "current-password"],
  ["new_password", "New password", "new-password-input", "new-password"],
  ["confirm_password", "Confirm new password", "confirm-password-input", "new-password"],
];

export function ChangePasswordPanel() {
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(false);
  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm_password) { toast.error("Passwords do not match."); return; }
    if (form.new_password.length < MIN_LENGTH) { toast.error(`Password must be at least ${MIN_LENGTH} characters.`); return; }
    setLoading(true);
    try {
      const r = await api.post("/auth/change-password", form);
      toast.success(r.data.message || "Password updated successfully.");
      setForm(EMPTY);
    } catch (err) {
      toast.error(formatApiError(err) || "Could not update password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="grid gap-3 sm:max-w-md" data-testid="change-password-form">
      {FIELDS.map(([key, label, tid, ac]) => (
        <label key={key} className="block">
          <span className="block text-xs font-bold text-navy mb-1">{label}</span>
          <PasswordInput id={`cp-${key}`} testid={tid} className={inputCls} value={form[key]} onChange={set(key)} autoComplete={ac} minLength={key === "current_password" ? undefined : MIN_LENGTH} />
        </label>
      ))}
      <button type="submit" disabled={loading} data-testid="change-password-button" className="min-h-[46px] rounded-xl bg-navy text-cream font-bold text-sm px-6 hover:bg-navy-light transition-colors inline-flex items-center justify-center gap-2 sm:w-fit disabled:opacity-60">
        <KeyRound className="w-4 h-4" /> {loading ? "Updating…" : "Update Password"}
      </button>
    </form>
  );
}
